import React from "react";
import { Button, Segment } from "semantic-ui-react";
import { UserModal } from "./UserModal";
import { LOADING } from "../../utils/helpers/phases";
import { TableWithPagination } from "../../components/TableView/TableWithPagination";
export const UsersComponent = props => {
  const headers = [
    { label: "E-mail", key: "email" },
    { label: props.t("user:firstnameText"), key: "firstname" },
    { label: props.t("user:surnameText"), key: "surname" }
  ];
  return (
    <Segment basic loading={props.phase === LOADING}>
      {props.isAdmin ? (
        <React.Fragment>
          <UserModal
            {...props}
            enableReinitialize
            initialValues={{
              ...props.selected
            }}
          />
          <Button
            color="orange"
            onClick={() => {
              props.toggleModal();
            }}>
            {props.t("user:addUserButton")}
          </Button>
        </React.Fragment>
      ) : (
        undefined
      )}
      <TableWithPagination
        headers={headers}
        data={props.users}
        showActionButtons={props.isAdmin}
        handleEditClick={user => props.toggleModal(user)}
        handleRemoveClick={({ userId }) => props.deleteUser(userId)}
      />
    </Segment>
  );
};



// WEBPACK FOOTER //
// ./src/users/UsersList/UsersComponent.js